import { translate } from "../../Services/translation";
import { CONSENT_COOKIE_GOOGLE_ANALYTICS, CONSENT_COOKIE_KEY, CONSENT_COOKIE_NECESSARY } from "../../rutab-constants";

export const GetCookiesToConsent = (cookies) => {

    const CheckIfCookieAccepted = (key) => {
        if (cookies[CONSENT_COOKIE_KEY] === undefined || cookies[CONSENT_COOKIE_KEY] === null) {
            return true;
        }

        let allowedServices = cookies[CONSENT_COOKIE_KEY]?.AllowedServices;

        return allowedServices.find(x => x == key) != null;
    }

    return [
        {
            key: CONSENT_COOKIE_NECESSARY,
            title: translate("cookie.necessary.cookie.title"),
            content: translate("cookie.necessary.cookie.info"),
            trackingServices: null,
            optional: false,
            accepted: true,
        },
        {
            key: CONSENT_COOKIE_GOOGLE_ANALYTICS,
            title: translate("cookie.google.analytics.cookie.title"),
            content: translate("cookie.google.analytics.cookie.body"),
            accepted: CheckIfCookieAccepted(CONSENT_COOKIE_GOOGLE_ANALYTICS),
            optional: true,
            trackingServices: {
                link: 'https://policies.google.com/privacy',
                header: 'Google analytics',
            }
        },
    ]
}